
export const ROLE_ADMIN_NAME = 'ADMIN'
export const ROLE_CONSTS = {
  SUPPER_ADMIN: 1,
  ADMIN: 2,
  BUSINESS_MANAGER: 100,
  PAGE_ADMIN: 120,
  BUSINESS_STAFF: 150,
  BLOG_EDITOR: 152,
  MEMBER: 200,
  GUEST: 255,
}

export const ROLES_NAME = {
  [ROLE_CONSTS.SUPPER_ADMIN]: 'Super Admin',
  [ROLE_CONSTS.ADMIN]: 'Admin',
  [ROLE_CONSTS.BUSINESS_MANAGER]: 'Giám đốc doanh nghiệp',
  [ROLE_CONSTS.PAGE_ADMIN]: 'Admin page',
  [ROLE_CONSTS.BUSINESS_STAFF]: 'Nhân viên trực page',
  [ROLE_CONSTS.BLOG_EDITOR]: 'Nhân viên quản lý blog',
  [ROLE_CONSTS.MEMBER]: 'Nhân viên',
  [ROLE_CONSTS.GUEST]: 'Khách',
};

export const ROLES_NEW = {
  SYSTEM_ROLE_SUPER_ADMIN: 'SYSTEM_ROLE_SUPER_ADMIN',
  SYSTEM_ROLE_ADMIN: 'SYSTEM_ROLE_ADMIN',
  SYSTEM_ROLE_MANAGER: 'SYSTEM_ROLE_MANAGER',
  SYSTEM_ROLE_PAGE_ADMIN: 'SYSTEM_ROLE_PAGE_ADMIN',
  SYSTEM_ROLE_STAFF: 'SYSTEM_ROLE_STAFF',
  SYSTEM_ROLE_BLOG_EDITOR: 'SYSTEM_ROLE_BLOG_EDITOR',
  SYSTEM_ROLE_MEMBER: 'SYSTEM_ROLE_MEMBER',
  SYSTEM_ROLE_GUEST: 'SYSTEM_ROLE_GUEST'
};